import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormInputTextAreaProps } from './types';
import { generatePlaceholderForInputField } from '../utils';

// components
import { InputTextArea } from '@ui';

const FormInputTextArea: React.FC<FormInputTextAreaProps> = ({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}) => {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    return generatePlaceholderForInputField(validationRules || [], t);
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <InputTextArea {...rest} placeholder={placeholder} />;
};
export default React.memo(FormInputTextArea);
